<template>
  <section class="section" v-if="getEbooks && getEbooks.length > 0">
      <h1 class="has-text-weight-bold">No ebook? 🤔You can also pick ebooks from our selection.</h1>
      <b-table :data="getEbooks"
            :paginated="true"
            :per-page="5"
            :loading="isLocalLoading"
            default-sort="title">
         <template slot-scope="props">
           <b-table-column field="title" label="Title" sortable>
            {{ props.row.title }}
           </b-table-column>
           <b-table-column field="author" label="Author" sortable>
            {{ props.row.author }}
           </b-table-column>
            <b-table-column>
              <button type="button" class="button is-white" @click="startReadEbook(props.row.id)" :disabled="!canStartReadingEbook" v-if="!props.row.isRead">
                  <span>Start reading!</span>
              </button>
              <div v-else-if="props.row.isCompleted">
                Completed
              </div>
              <div v-else>
                In progress
              </div>
           </b-table-column>
         </template>
          <template slot="footer">
              <div class="has-text-right">
                  {{ getEbooksCount }}
              </div>
          </template>
      </b-table>
  </section>
</template>

<script>
export default {
  name: 'publicEbooksList',
  data () {
    return {
      columns: [{
        field: 'title',
        label: 'Title'
      }, {
        field: 'author',
        label: 'Author'
      }]
    }
  },
  created () {
    this.getFreeEbooks()
  },
  methods: {
    getFreeEbooks () {
      this.$store.dispatch('getFreeEbooks')
    },
    startReadEbook (ebookId) {
      this.$store.dispatch('startReadEbook', { ebookId })
    }
  },
  computed: {
    canStartReadingEbook () {
      return this.$store.getters.getUserTicketsCount > 0 || this.isSubscribedUser
    },
    getEbooks () {
      return this.$store.getters.getEbooks
    },
    getEbooksCount () {
      const ebooks = this.$store.getters.getEbooks
      if (ebooks) {
        const count = ebooks.length
        if (count === 1) {
          return '1 ebook'
        } else {
          return `${count} ebooks`
        }
      }
      return 'no ebook'
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'publicEbooksList' && localLoading.active
    },
    isSubscribedUser () {
      return this.$store.getters.isSubscribedUser
    }
  }
}
</script>

<style>

</style>
